import { render, staticRenderFns } from "./RespondsTableTab.vue?vue&type=template&id=14098f22&scoped=true"
import script from "./RespondsTableTab.vue?vue&type=script&lang=js"
export * from "./RespondsTableTab.vue?vue&type=script&lang=js"
import style0 from "./RespondsTableTab.vue?vue&type=style&index=0&id=14098f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14098f22",
  null
  
)

export default component.exports